module.exports = __webpack_public_path__ + "static/reward.bdc99d31.png";